/** One packaging report: its filters live in the URL so a report can be bookmarked or shared. */
import {
  PACKAGING_REPORT_PERMISSION,
  isPackagingReportSlug,
  packagingReportKey,
} from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { PackagingReportPage } from "@/features/packaging/reports/packaging-reports-pages";
import { reportSearch } from "@/features/warehouse/reports/api";

export const Route = createFileRoute("/_app/reports/packaging/$slug")({
  validateSearch: reportSearch,
  // The report's own code opens it (each report has one, as every report does).
  beforeLoad: ({ params }) => {
    if (!isPackagingReportSlug(params.slug))
      throw redirect({ to: "/reports/packaging" });
    const code = PACKAGING_REPORT_PERMISSION[packagingReportKey(params.slug)];
    if (!useAuth.getState().can(code))
      throw redirect({ to: "/reports/packaging" });
  },
  component: Page,
});

function Page() {
  const { slug } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  if (!isPackagingReportSlug(slug)) return null;
  return (
    <PackagingReportPage
      key={slug}
      slug={slug}
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
